import { useAtomValue } from 'jotai';
import { PermissionKey } from '../../../services/PermissionAndRolesKeys';
import { PermissionService } from '../../../services/PermissionService';
import { columnsRawLoadable } from '../../../services/state/AdminPanel/ColumnDefinitionsState';
import { ColumnMeta, createColumnMeta } from '../../../types';
import { ErrorOccurredMessage } from '../../CompanyProfiles/components/Messages/HelpMessage';
import { GenericConfigPage } from '../Common/GenericConfigPage';
import { columnFormTransformer, getColumnFields, transformColumnBeforeSubmit } from './ColumnFields';

const DEFAULT_FORM_VALUES: Partial<ColumnMeta> = createColumnMeta({
  id: 0,
  visible: true,
  type: 'string',
  formatting: 'string',
});

export function ConfigColumns() {
  const hasAccess = PermissionService.get().hasPermission(PermissionKey.customerSuccessAll);
  const loadable = useAtomValue(columnsRawLoadable);

  if (!hasAccess) {
    return null;
  }
  if (loadable.state === 'hasError') {
    return <ErrorOccurredMessage />;
  }
  if (loadable.state === 'loading') {
    return null;
  }

  const data = loadable.data ?? [];

  return (
    <GenericConfigPage<ColumnMeta>
      pageTitle='Columns'
      baseTitle='Column'
      data={data}
      fields={[]}
      formFields={getColumnFields()}
      queryURL='/column'
      defaultValues={DEFAULT_FORM_VALUES}
      transformBeforeSubmit={transformColumnBeforeSubmit}
      dynamicFormTransformer={columnFormTransformer}
    />
  );
}
